import { AxInit, ModuleName } from "../../../Lib/AxSystem/AxInit";
import { ProductMapper } from "../../../Lib/Mapper/ProductMapper";
import { AxLimeStone } from "../../../Limestone/AxLimeStone";
import { AxProdNonPredateableInit, NonPreDateable } from "../Abstraction/NonPreDateable";
import { IAddToCartRequest } from "../../../Models/Tickets/IAddToCartRequest";

@ModuleName("AxProdNonPredateable")
export class AxProdNonPredateable extends NonPreDateable implements AxInit {
    public ProjNr: number;
    public PoolNr: number;
    public TicketTypeNr: number;

    constructor(private _ProductMapper = new ProductMapper(),
            private _AxLimestone = new AxLimeStone()) { super(); }

    AxInit(initData: AxProdNonPredateableInit): void {
        this.ProjNr = initData.ProjNr;
        this.PoolNr = initData.ProductGroupIdentifier;
        this.TicketTypeNr = initData.Id;

        $('.prod_selection__persontype-submit').click(e => {
            this._AxLimestone.LockButton(e.delegateTarget);
            this.ToSummary();
        });

        this.Init(initData);
    }

    ToSummary(): void {
        if (this._TicketList.ProductList.filter(x => x.Quantity > 0).length > 0) {
            let requestObj: IAddToCartRequest = {
                Date: moment().format('YYYY-MM-DD'),
                ProjNr: this.ProjNr,
                PoolNr: this.PoolNr,
                TicketTypeId: this.TicketTypeNr,
                PersonTypes: this._ProductMapper.GetPersonTypeList(this._TicketList.ProductList),
            };

            this._summaryRedirect.redirect(this.PostURL, requestObj, false);
        }
    }
}
